import { Route, Routes } from '@angular/router';
import { rutaInformes } from '@nebula-shared/ui';
import {
  DATA_MODULO_EN_CONSTRUCCION,
  MODULOS_EN_CONSTRUCCION,
} from './const/src/lib/modules.constant';

export const LAYOUT_ROUTES: Routes = [];

/** Ruta del «Centro de Tareas» dentro de cada producto (HT_ARQ_013, RN-TAR-080). */
export const CENTRO_TAREAS_PATH = 'tareas/list';

/**
 * El «Centro de Tareas» es transversal: cada producto agrega esta ruta a sus hijas, de modo que la
 * opcion del menu resuelve igual en todos (`/layout/<producto>/tareas/list`).
 */
export const RUTA_CENTRO_TAREAS: Route = {
  path: CENTRO_TAREAS_PATH,
  // Bajo demanda: este archivo lo exporta el barril del layout que la aplicacion importa al
  // arrancar, y con `component` el Centro de Tareas entero entraba al bundle inicial (pasaba el
  // presupuesto de 4 MB).
  loadComponent: () =>
    import('./feature-layout/src/lib/centro-tareas/centro-tareas.component').then(
      (m) => m.CentroTareasComponent,
    ),
  title: 'OPTIONS_TASK_CENTER',
  data: { breadcrumb: 'OPTIONS_TASK_CENTER', i18n: true },
};

/**
 * Rutas de los productos de la fase 2 en construccion (`/layout/<modulo>/...`): el contenedor de
 * pestañas del producto y, para cualquier opcion de su menu, la pantalla «En construccion». Bajo
 * demanda, por la misma razon que el Centro de Tareas.
 */
export const RUTAS_EN_CONSTRUCCION: Routes = MODULOS_EN_CONSTRUCCION.map((modulo) => ({
  path: modulo,
  loadComponent: () =>
    import('./feature-layout/src/lib/en-construccion/modulo-en-construccion.component').then(
      (m) => m.ModuloEnConstruccionComponent,
    ),
  data: {
    showSidebar: true,
    showHeader: true,
    showBreadcrumb: true,
    [DATA_MODULO_EN_CONSTRUCCION]: modulo,
  },
  children: [
    // «Informes», antes del comodin: el producto en construccion muestra el aviso de sin informes
    rutaInformes(modulo),
    {
      path: '**',
      loadComponent: () =>
        import('./feature-layout/src/lib/en-construccion/en-construccion.component').then(
          (m) => m.EnConstruccionComponent,
        ),
    },
  ],
}));
